/**
 * GET-LABEL
 * Get label for template element according language
 */

import { store } from "@/index"
import { SESSION_DEFAULT_LANGUAGES } from "@/redux/_session.types"
import i18n from "@/translate/i18n"

//Matches the new "$entreprise" variable (same $tag convention as the email tags in
//mail.utils.ts:formatContent) and the older ad-hoc bracket placeholders template authors
//already typed by hand ("[entreprise]", "[nom de l'entreprise]"...) — found live in DB,
//2026-09-16. Substituted here only, never persisted: this is the single place every
//Question/Topic/Axis label already flows through (Question.label calls getLabel(this.name)),
//so every display surface (dashboards, PPTX export via DOM screenshot, GPT prompts) picks
//this up for free without patching each render site individually.
const ACCOUNT_NAME_VARIABLE_REGEX = /\$entreprise\b|\[\s*(entreprise|société|nom de l'entreprise|nom de la société)\s*\]/gi

const substituteAccountName = (label: string) => {
  if (!label) return label
  const accountName = store.getState()._session.accountName
  //No account name in this session — leave the token as-is rather than blanking it out into
  //an awkward gap in the sentence (found live, 2026-09-16, qv preview: "chez ." instead of
  //"chez [entreprise]."). Only applies here to the raw supervisor / no-account contexts.
  if (!accountName) return label
  return label.replace(ACCOUNT_NAME_VARIABLE_REGEX, accountName)
}

const getLabel = (name:any) => {

  const initialLanguage = store.getState()._session.userInitialLanguage
  let label = SESSION_DEFAULT_LANGUAGES.indexOf(initialLanguage) === -1 ? name[initialLanguage] : name[i18n.language]

  if (label){
    return substituteAccountName(label)
  }else{

    //Fallback english if exist
    if (name["en"]){
      return substituteAccountName(name["en"])
    }
    //Search first other language
    else{

      label = ""
      for (const [key] of Object.entries(name)) {
        label = name[key]
        break
      }

      return substituteAccountName(label)

    }

  }
}

export default getLabel